/*
 * @Descripttion: sku商品商品选择组件
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState, useCallback } from 'react';
import { Radio, Button, Form, Input, Tab, Table } from '@alifd/next';
import styles from './index.module.scss';
import SelectGoods from '@/components/CrowdTagSelectGoodProductId/index';

/**
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 */
const TagSku = ({
  changeData = (data) => {
  }, tagItem = {},
}) => {
  const [data, setData] = useState(tagItem?.opValue?.param_list?.[0]?.param_id?.[0]); // radio选中的值
  // 选中的skuid
  const [skuIds, setSkuIds] = useState(tagItem?.opValue?.param_list.length > 0 ? tagItem?.opValue?.param_list[0]?.sub_param_list.map(item => item.param_str) : []);
  // 选中的商品【其实应该和skuid一起做处理的，能用就行】
  const [selectGoods, setSelectGoods] = useState(tagItem?.opValue?.param_list.length > 0 ? tagItem?.opValue?.param_list[0]?.sub_param_list.map(item => {return {skuId: item.param_str}}) : []);

  // 是否展示弹窗
  const [isShow, setIsShow] = useState(false);

  /**
   * 展示选择sku的弹窗
   */
  const showWdDialog = () => {
    setIsShow(true);
  };

  /**
   * 选择完毕关闭弹窗
   */
  const confirm = (v) => {
    setSkuIds(v);
    changeData({
      opValue: {
        label_id: tagItem.id,
        param_list: [
          {
            param_id: data ? [data] : [],
            sub_param_list: v.map((item) => {
              return {
                param_str: item.toString()
              }
            })
          }
        ]
      }, opType: 'ALL'
    });
    setIsShow(false);
  };


  /**
   * 选择时改变要处理成字符串形式传给父组件
   */
  const changeValue = (val) => {
    setData(val);
    changeData({
      opValue: {
        label_id: tagItem.id,
        param_list: [
          {
            param_id: [val],
            sub_param_list: skuIds.map((item) => {
              return {
                param_str: item.toString()
              }
            })
          }
        ]
      },
      opType: 'ALL'
    });
  };
  const tagNumbers = useCallback(() => {
    if (tagItem.opValue) {
      // 计算出tagItem.opValue.param_list中，二级类目的数量
      const count = tagItem?.opValue?.param_list?.reduce((pre, cur) => {
        return pre + cur.sub_param_list.length;
      }, 0);
      // 如果二级类目的数量大于0，则显示“已选X个”，否则显示“已选0个”
      const selectedCount = count > 0 ? count : 0;
      return selectedCount;
    }
  }, [tagItem.opValue]);

  useEffect(() => {
    if (tagItem.opValue) {
      // searchSku({ skuIds: tagItem.opValue.join(',') }, 2, true); // 如果是反显，需要通过所选id查出具体值放到已选列表，tip传2
    }
  }, []);

  return (
    <div className={`${styles['tag-skus']} tag-width`}>
      <Radio.Group value={data} onChange={(val) => changeValue(val)}>
        {
          tagItem.value.map((its, ins) => (<Radio
            style={{ marginBottom: '10px', marginLeft: '0px', marginRight: '8px' }}
            key={ins}
            value={its.realValue}
          >
            {its.fieldValue}
          </Radio>))
        }
      </Radio.Group>
      <div
        className={styles['special-tag-wd']}
        onClick={showWdDialog}
      >选择（已选<span>{tagNumbers() ?? 0}</span>个） &gt;&gt;
      </div>
      {
        skuIds.length <= 0 && <div style={{ color: "#f33" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelDescription}
        </div>
      }

      {
        isShow && (
          <SelectGoods
              goodsDialog={isShow}
              closeDialog={() => setIsShow(false)}
              skuIds={skuIds}
              confirmSkuid={(v) => confirm(v)}
              selectGoods={selectGoods}
              confirmGoods={(v) => {
                setSelectGoods(v);
              }}
            />
        )
      }

    </div>
  );
};
export default TagSku;
